/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// SWYM only checks for window.CartJS as a callback from adding to cart from wishlist,
// and we're not actually using that setup, so we'll fake it and do what we actually need
window.CartJS = {
	getCart: function () {
		document.documentElement.dispatchEvent(new CustomEvent('product:added', {
			bubbles: true,
			detail: {
				quantity: 1
			}
		}));
	}
}


// Add back button dynamically
if (window.location.href.indexOf('?app=true') > -1 || window.sessionStorage.getItem('in-app')) {
	window.sessionStorage.setItem('in-app', '1');
	// 	if (window.history.length > 2)
	// 	{
	document.body.classList.add('in-app');
	// 	}
}

document.querySelectorAll('[data-action="go-back"]').forEach(link => {
	link.addEventListener('click', e => {
		e.preventDefault();
		window.history.back();
	});
});


// Random
function triggerEvent(el, type) {
	// IE9+ and other modern browsers
	if ('createEvent' in document) {
		var e = document.createEvent('HTMLEvents');
		e.initEvent(type, false, true);
		el.dispatchEvent(e);
	} else {
		// IE8
		var e = document.createEventObject();
		e.eventType = type;
		el.fireEvent('on' + e.eventType, e);
	}
}



window.addEventListener('DOMContentLoaded', (event) => {
	let _width = window.outerWidth;
	let mobile_switch_wrapper = document.querySelector('.holiday-switch-mobile');
	const holiday_switch_wrapper = document.querySelector('.holiday-switch');
	const holiday_switch = document.querySelector('.holiday-switch input[type="checkbox"]');
	const mdPrimaryBtn = document.querySelectorAll('.holiday-primary');
	const mdSecondaryBtn = document.querySelectorAll('.holiday-secondary');
	const popup_holidayEl = document.querySelector('.popup-holiday');

	if (_width < 1000) {
		mobile_switch_wrapper.append(holiday_switch_wrapper);
	}
	window.addEventListener('resize', () => {
		_width = window.outerWidth;
		if (_width < 1000) {
			mobile_switch_wrapper.append(holiday_switch_wrapper);
		}
	})
	holiday_switch.addEventListener("change", (event) => {
		setTimeout(() => {
			init_Holiday();
		}, 50);
	})


	mdPrimaryBtn.forEach((PrimaryBtn) => {
		PrimaryBtn.addEventListener('click', function () {
			const cookieThanksgiving = document.querySelector('.holiday-switch').dataset.cookie;
			const is_checked = holiday_switch.checked;

			if (!is_checked) {
				holiday_switch.checked = true;
				let fm_thanksgiving = getCookie(cookieThanksgiving);
				setCookie(cookieThanksgiving, '1');


				init_Holiday();
				applyThanksgiving();
				// popup_holidayEl.style.display = "none";
			}
		})
	});






	mdSecondaryBtn.forEach((SecondaryBtn) => {
		SecondaryBtn.addEventListener('click', function () {
			const cookieThanksgiving = document.querySelector('.holiday-switch').dataset.cookie;
			const is_checked = holiday_switch.checked;

			if (is_checked) {
				holiday_switch.checked = false;
				let fm_thanksgiving = getCookie(cookieThanksgiving);
				setCookie(cookieThanksgiving, ' ');
				// console.log(pdtItemBtn);
				init_Holiday();
				applyThanksgiving();
				// popup_holidayEl.style.display = "none";
			}
		})
	});



});

const headerEl = document.querySelector('.shopify-section__header .header--inline');
const announcement_barEl = document.querySelector('.announcement-bar .announcement-bar__content');
const siteLogoEl = document.querySelector('.header__logo-image');
const modal_holidayEl = document.querySelector('.modal--holiday');
const popup_holidayEl = document.querySelector('.popup-holiday');
const atcWrapperEl = document.querySelector('.atc-wrapper');
const fmHolidayBtn = document.querySelector('.fm-holiday__popup-button');
const holidayStyle = document.querySelector('#holiday-style');
const normalStyle = document.querySelector('#normal-style');
const holidayPillEl = document.querySelector('.holiday-pill');

const defaultHeaderClr = headerEl.style.color;
const defaultABarText = announcement_barEl.innerText;
const defaultLogoSrc = siteLogoEl.src;


//window


function init_Holiday() {
	const cookieThanksgiving = document.querySelector('.holiday-switch').dataset.cookie;
	const fm_thanksgiving = getCookie(cookieThanksgiving);
  console.log('init_Holiday', fm_thanksgiving);
	setTimeout(function () {
		switch (fm_thanksgiving) {
			case "1":
				var logoSrc = window.holidaySettings.holiday_logo;
				headerEl.style.backgroundColor = window.holidaySettings.holiday_color;
				if (window.holidaySettings.holiday_banner_text) {
					announcement_barEl.innerText = window.holidaySettings.holiday_banner_text;
				}
				if (logoSrc) {
					siteLogoEl.src = logoSrc;
				}
				if (atcWrapperEl && atcWrapperEl.classList.contains('fm-holiday-trigger')) {
					console.log('true');
					atcWrapperEl.style.display = "block";
					fmHolidayBtn.style.display = "none";
				}
				if (document.querySelector('#normal-style')) {
					document.querySelector('#normal-style').remove();
				}
				document.querySelector('head').append(holidayStyle);
				// holidayPillEl.style.display = "inline-block";
				break;
			default:
				// modal_holidayEl.setAttribute('style', 'display', 'none !important');
				headerEl.style.backgroundColor = defaultHeaderClr;
				announcement_barEl.innerText = defaultABarText;
				siteLogoEl.src = defaultLogoSrc;
              
				if (fmHolidayBtn && fmHolidayBtn.classList.contains('popup-trigger')) {
					atcWrapperEl.style.display = "none";
					fmHolidayBtn.style.display = "block";
				}
				if (document.querySelector('#holiday-style')) {
					document.querySelector('#holiday-style').remove();
				}
				document.querySelector('head').append(normalStyle);
				// holidayPillEl.style.display = "none";
				// document.querySelector('.popup-holiday').
				break;

		}
	}, 50);

}
init_Holiday();

// get cookie function

// $(window).on("load", function () {
// 	const holiday_switch = document.querySelector('.holiday-switch input[type="checkbox"]');
// 	if (holiday_switch.checked == false) {
// 		setTimeout(() => {
// 			console.log("false");
// 			$("#modal-holiday").attr("aria-hidden", false);
// 		}, 2500);
// 	}

// });




// closeIcon = document.querySelectorAll('.popup-holiday__close');
// noRegularShopping = document.querySelectorAll('.holiday-primary');
// yesHolidayMode = document.querySelectorAll('.holiday-secondary');


// closeIcon.forEach(element => {
// 	element.addEventListener('click', function () {
// 		document.querySelector('#modal-holiday').setAttribute("aria-hidden", true);
// 	})
// });

// noRegularShopping.forEach(element => {
// 	element.addEventListener('click', function () {
// 		document.querySelector('#modal-holiday').setAttribute("aria-hidden", true);
// 	})
// });

// yesHolidayMode.forEach(element => {
// 	element.addEventListener('click', function () {
// 		document.querySelector('#modal-holiday').setAttribute("aria-hidden", true);
// 	})
// });


